import { Component } from '@angular/core';
import { TranslatorService } from '../../../services/translator_service';
import { ResponsiveService } from '../../../services/responsive.service';
import { MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-disclosure-modal',
  imports: [TranslatePipe,CommonModule],
  templateUrl: './disclosure-modal.html',
  styleUrl: './disclosure-modal.scss',
})
export class DisclosureModal {
  isMobile: boolean;
  currentLang;
  translationsObj;

  constructor(private responsiveService: ResponsiveService,private translator: TranslatorService,
    private dialogRef: MatDialogRef<DisclosureModal>
  ) {
    this.dialogRef.disableClose = true;
    this.translator.currentLangEmitter$.subscribe(async (value) => {
      this.translationsObj = await this.translator.getTranslation(value).toPromise();
      this.currentLang = value;
    });
  }

  ngOnInit() {
    this.onResize();
    this.responsiveService.checkWidth();
  }

  onResize() {
    this.responsiveService.getMobileStatus().subscribe((isMobile) => {
      this.isMobile = isMobile;
    });
  }

  onAgree(){
    let data = {
      status: 1,
    }
    this.dialogRef.close(data);
  }

  onClose(){
    let data = {
      status: 0,
    }
    this.dialogRef.close(data);
  }
}
